/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

const KEY = "app-redirect-pathname";

/** Where an anonymous visitor was headed (pathname plus search); the login flow returns them there. */
export function storeLoginRedirect(target: string): void {
  sessionStorage.setItem(KEY, target);
}

export function peekLoginRedirect(): string | null {
  return sessionStorage.getItem(KEY);
}

export function clearLoginRedirect(): void {
  sessionStorage.removeItem(KEY);
}

export function takeLoginRedirect(): string | null {
  const target = peekLoginRedirect();
  clearLoginRedirect();
  return target;
}
